const Pip = (() => {
    // Bounding Box
    function boundingBoxAroundPolyCoords(coords) {
        var xAll = [];
        var yAll = [];

        for (var i = 0; i < coords[0].length; i++) {
            xAll.push(coords[0][i][1]);
            yAll.push(coords[0][i][0]);
        }

        xAll = xAll.sort(function (a, b) {
            return a - b;
        });
        yAll = yAll.sort(function (a, b) {
            return a - b;
        });

        return [[xAll[0], yAll[0]], [xAll[xAll.length - 1], yAll[yAll.length - 1]]];
    }

    var pointInBoundingBox = function (point, bounds) {
        return !(point.coordinates[1] < bounds[0][0] || point.coordinates[1] > bounds[1][0] || point.coordinates[0] < bounds[0][1] || point.coordinates[0] > bounds[1][1]);
    };

    // Point in Polygon
    // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html#Listing the Vertices

    function pnpoly(x, y, coords) {
        var vert = [[0, 0]];

        for (var i = 0; i < coords.length; i++) {
            for (var j = 0; j < coords[i].length; j++) {
                vert.push(coords[i][j]);
            }
            vert.push(coords[i][0]);
            vert.push([0, 0]);
        }

        var inside = false;
        for (var i = 0, j = vert.length - 1; i < vert.length; j = i++) {
            if (((vert[i][0] > y) != (vert[j][0] > y)) && (x < (vert[j][1] - vert[i][1]) * (y - vert[i][0]) / (vert[j][0] - vert[i][0]) + vert[i][1])) inside = !inside;
        }

        return inside;
    }

    var pointInPolygon = function (p, poly) {
        var coords = (poly.type == 'Polygon') ? [poly.coordinates] : poly.coordinates;

        var insideBox = false;
        for (var i = 0; i < coords.length; i++) {
            if (pointInBoundingBox(p, boundingBoxAroundPolyCoords(coords[i]))) insideBox = true;
        }
        if (!insideBox) return false;

        var insidePoly = false;
        for (var i = 0; i < coords.length; i++) {
            if (pnpoly(p.coordinates[1], p.coordinates[0], coords[i])) insidePoly = true;
        }

        return insidePoly;
    };

    // var numberToRadius = function (number) {
    //     return number * Math.PI / 180;
    // };

    // var numberToDegree = function (number) {
    //     return number * 180 / Math.PI;
    // };

    // // from http://www.movable-type.co.uk/scripts/latlong.html
    // var pointDistance = function (pt1, pt2) {
    //     var lon1 = pt1.coordinates[0];
    //     var lat1 = pt1.coordinates[1];
    //     var lon2 = pt2.coordinates[0];
    //     var lat2 = pt2.coordinates[1];
    //     var dLat = numberToRadius(lat2 - lat1);
    //     var dLon = numberToRadius(lon2 - lon1);
    //     var a = Math.sin(dLat / 2) ** 2 + Math.cos(numberToRadius(lat1))
    //         * Math.cos(numberToRadius(lat2)) * Math.sin(dLon / 2) ** 2;
    //     var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    //     return (6371 * c) * 1000; // returns meters
    // };

    // // adapted from http://paulbourke.net/geometry/polyarea/javascript.txt
    // var area = function (polygon) {
    //     var area = 0;
    //     var points = polygon.coordinates[0];
    //     var j = points.length - 1;
    //     var p1;
    //     var p2;
    //
    //     for (var i = 0; i < points.length; j = i++) {
    //         var p1 = {
    //             x: points[i][1],
    //             y: points[i][0]
    //         };
    //         var p2 = {
    //             x: points[j][1],
    //             y: points[j][0]
    //         };
    //         area += p1.x * p2.y;
    //         area -= p1.y * p2.x;
    //     }
    //
    //     area /= 2;
    //     return area;
    // };

    var isPoly = function (l) {
        return l.feature &&
            l.feature.geometry &&
            l.feature.geometry.type &&
            ['Polygon', 'MultiPolygon'].indexOf(l.feature.geometry.type) !== -1;
    };

    var pointInLayer = function (p, layer, first) {
        if (typeof p.lat === 'number') p = [p.lng, p.lat];
        else if (Pip.bassackwards) p = p.concat()
            .reverse();

        var results = [];

        layer.eachLayer(function (l) {
            if (first && results.length) return;

            if (isPoly(l) && pointInPolygon({
                type: 'Point',
                coordinates: p
            }, l.toGeoJSON().geometry)) {
                results.push(l);
            }
        });
        return results;
    };

    return {
        bassackwards: false,

        pointInLayer: pointInLayer
    };
})();

export default Pip;
